import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContenidoState } from './contenido.reducers';
import * as fromContenido from './contenido.reducers';

export const contenidoState = createFeatureSelector<ContenidoState>("contenido");

export const allContenido = createSelector(
	contenidoState,
	fromContenido.selectAll
);

export const contenidoReady = createSelector(
	contenidoState,
	state => state.ready
);

export const contenidoMorePagesToLoad = createSelector(
	contenidoState,
	state => state.morePagesToLoad
);

export const contenidoNextPageNum = createSelector(
	contenidoState,
	state => state.nextPageNum
);

export const contenidoPageSize = createSelector(
	contenidoState,
	state => state.pageSize
);

export const contenidoStatus = createSelector(
	contenidoState,
	state => state.status	
);

export const contenidoCleared = createSelector(
	contenidoState,
	state => state.cleared
);
